import React, { useEffect, useMemo, useState } from "react";
import { discordAPI } from "../../../api/apiClient";
import useApi from "../../CustomHooks/useApi";
import Loading from "../../../Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../../css/Views/MembershipDiscord.css";

const MembershipDiscordSelector = ({ value, displayName, onChange }) => {
    const { callApi, isLoading } = useApi();
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        callApi(() => discordAPI.users.getAll(), (data) => setUsers(Array.isArray(data) ? data : []));
    }, []);

    const selectedUser = useMemo(() => users.find((user) => String(user.id) === String(value)), [users, value]);
    const searchTerm = search.trim().toLocaleLowerCase("pl");
    const filteredUsers = useMemo(() => {
        if (!searchTerm) return [];
        return users.filter((user) => `${user.displayName ?? ""} ${user.username ?? ""}`.toLocaleLowerCase("pl").includes(searchTerm)).slice(0, 12);
    }, [users, searchTerm]);

    if (value) {
        const label = selectedUser?.displayName || selectedUser?.username || displayName || value;
        return <div className="membership-discord-selected">{selectedUser?.avatarUrl ? <img src={selectedUser.avatarUrl} alt="" /> : <div className="membership-discord-avatar-placeholder">D</div>}<div className="membership-discord-selected-info"><strong>{label}</strong>{selectedUser?.username && selectedUser.username !== label && <span>@{selectedUser.username}</span>}</div><button type="button" onClick={() => onChange(null, null)} title="Usuń powiązanie Discord"><FontAwesomeIcon icon={faTimes} /></button></div>;
    }

    return (
        <div className="membership-discord-selector">
            <div className="membership-discord-search"><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Wyszukaj osobę na Discordzie..." /></div>
            {searchTerm && (isLoading ? <div className="membership-discord-results"><div className="membership-discord-loading"><Loading text="Ładowanie Discorda..." /></div></div> : <div className="membership-discord-results">{filteredUsers.length === 0 ? <div className="membership-discord-empty">Brak pasujących osób.</div> : filteredUsers.map((user) => <button key={user.id} type="button" className="membership-discord-result" onClick={() => onChange(String(user.id), user.displayName || user.username)}>{user.avatarUrl ? <img src={user.avatarUrl} alt="" /> : <div className="membership-discord-avatar-placeholder">D</div>}<span><strong>{user.displayName || user.username}</strong>{user.username && user.username !== user.displayName && <small>@{user.username}</small>}</span></button>)}</div>)}
        </div>
    );
};

export default MembershipDiscordSelector;
